export const VAT_PERCENTAGES = {
  SRG: '5',
  ZRG: '0',
  OOS: '0',
  NOVAT: '0',
  SRS: '5',
}

export const VAT_CLASS_OPTIONS = Object.keys(VAT_PERCENTAGES).map((key) => ({
  label: key,
  value: key,
  disabled: false,
}))
